import React, { useEffect, useState } from "react";

interface FilterProps {
  onTabChange?: (tab: "pendentes" | "pagos") => void;
  isLoading?: boolean;
  activeTab?: "pendentes" | "pagos";
}

export default function Filter({ onTabChange, isLoading, activeTab }: FilterProps) {
  const [internalActiveTab, setInternalActiveTab] = useState<"pendentes" | "pagos">("pendentes");
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (activeTab) {
      setInternalActiveTab(activeTab);
    }
  }, [activeTab]);

  const handleTabClick = (tab: "pendentes" | "pagos") => {    
    if (disabled || tab === internalActiveTab) {
      return;
    }
    
    setInternalActiveTab(tab);
    setDisabled(true);
    if (onTabChange) {
      onTabChange(tab);
    }
  };

  useEffect(() => {
    if (!isLoading && disabled) {
      setDisabled(false);
    }
  }, [isLoading, disabled]);

  return (
    <div className="flex gap-4 mb-8">
      <button
        type="button"
        disabled={disabled || isLoading}
        className={`flex-1 py-2 border rounded-lg transition-all duration-500 ease-in-out ${
          internalActiveTab === "pendentes"
            ? "bg-black text-white border-black"
            : "border-gray-400 text-gray-700 hover:bg-gray-100"
        } ${(disabled || isLoading) ? "opacity-50 cursor-not-allowed" : "opacity-100 cursor-pointer"}`}
        onClick={() => handleTabClick("pendentes")}
      >
        Pendentes
      </button>
      <button
        type="button"
        disabled={disabled || isLoading}
        className={`flex-1 py-2 border rounded-lg transition-all duration-500 ease-in-out ${
          internalActiveTab === "pagos"
            ? "bg-black text-white border-black"
            : "border-gray-400 text-gray-700 hover:bg-gray-100"
        } ${(disabled || isLoading) ? "opacity-50 cursor-not-allowed" : "opacity-100 cursor-pointer"}`}
        onClick={() => handleTabClick("pagos")}
      >
        Pagos
      </button>
    </div>
  );
}
